module.exports = __webpack_public_path__ + "static/media/noun_Settings_2650515.e941f7b0.svg";